/*
 *
 *GalleryPage constants
 *
 */
export const FETCH_GALLERY_REQUEST = "src/GalleryPage/FETCH_GALLERY_REQUEST";
export const FETCH_GALLERY_FAILURE = "src/GalleryPage/FETCH_GALLERY_FAILURE";
export const FETCH_GALLERY_SUCCESS = "src/GalleryPage/FETCH_GALLERY_SUCCESS";
export const DELETE_GALLERY_REQUEST = "src/GalleryPage/DELETE_GALLERY_REQUEST";
export const DELETE_GALLERY_FAILURE = "src/GalleryPage/DELETE_GALLERY_FAILURE";
export const DELETE_GALLERY_SUCCESS = "src/GalleryPage/DELETE_GALLERY_SUCCESS";
